<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    :ok-text="saveText"
    cancel-text="取消"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="基地名称" prop="baseName">
          <a-input
            v-model="form.baseName"
            placeholder="请输入基地名称"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="基地建设时间" prop="baseFoundTime">
          <a-date-picker
            v-model="form.baseFoundTime"
            :locale="locale"
            style="width: 100%"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="基地类别" prop="baseType">
          <a-select
            v-model="form.baseType"
            placeholder="请选择基地类别"
            :disabled="disabeld"
          >
            <a-select-option
              :value="item.value"
              v-for="item in jdlbList"
              :key="item.value"
              >{{ item.title }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="省" prop="province">
          <a-select
            v-model="form.province"
            @change="handleChange"
            placeholder="请选择省"
            :disabled="disabeld"
          >
            <a-select-option
              :value="item.code"
              v-for="(item, index) in plist"
              :key="index"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="市" prop="city">
          <a-select
            v-model="form.city"
            @change="handleChange1"
            placeholder="请选择市"
            :disabled="disabeld"
          >
            <a-select-option
              :value="item.code"
              v-for="(item, index) in clist"
              :key="index"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="区/县" prop="area">
          <a-select
            v-model="form.area"
            placeholder="请选择区/县"
            :disabled="disabeld"
          >
            <a-select-option
              :value="item.code"
              v-for="(item, index) in alist"
              :key="index"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="基地建设地址" prop="baseAddress">
          <a-input
            v-model="form.baseAddress"
            placeholder="请输入基地建设地址"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="封面图" prop="coverImg" ref="coverImg">
          <a-upload
            name="avatar"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            accept=".png,.jpg,.jpeg"
            v-model="form.coverImg"
            :disabled="disabeld"
            :before-upload="(file, fileList) => beforeUpload(file, fileList)"
            @change="handleUploadChange"
          >
            <img
              v-if="form.coverImg"
              :src="sj(form.coverImg)"
              class="imgs"
              alt="avatar"
            />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text" :disabled="disabeld">上传封面图</div>
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="内容" prop="content">
          <base-editor
            ref="baseEditor"
            :height="250"
            :text="form.content"
            v-model="form.content"
            :disabled="disabeld"
            style="z-index: 1000"
          ></base-editor>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>
  
<script>
import { getAction, postAction, putAction, fileUpdate } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
import BaseEditor from "@/components/common/BaseEditor.vue";
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        baseName: "",
        province: "",
        baseFoundTime: "",
        city: "",
        area: "",
        baseAddress: "",
        coverImg: "",
        content: "",
        baseType: "",
      },
      loading: false,
      rules: {
        baseName: [
          {
            required: true,
            message: "请输入基地名称",
            trigger: "blur",
          },
        ],
        baseFoundTime: [
          {
            required: true,
            message: "请选择基地建设时间",
            trigger: "change",
          },
        ],
        baseType: [
          {
            required: true,
            message: "请选择基地类别",
            trigger: "change",
          },
        ],
        province: [
          {
            required: true,
            message: "请选择省",
            trigger: "change",
          },
        ],
        city: [
          {
            required: true,
            message: "请选择市",
            trigger: "change",
          },
        ],
        area: [
          {
            required: true,
            message: "请选择区",
            trigger: "change",
          },
        ],
        baseAddress: [
          {
            required: true,
            message: "请输入基地建设地址",
            trigger: "blur",
          },
        ],
        coverImg: [
          {
            required: true,
            message: "请上传封面图",
            trigger: "change",
          },
        ],
        content: [
          {
            required: true,
            message: "请填写内容",
            trigger: "change",
          },
        ],
      },
      plist: [],
      clist: [],
      alist: [],
      zh_CN,
      locale,
      applyType: 2,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      jdlbList: [],
      disabeld: false,
      taskId: null,
      detailId: null,
      saveText: "保存",
    };
  },
  components: { BaseEditor },
  methods: {
    getjdlbList(ids) {
      getAction("/baseCommon/getDictItemsByCode?code=base_type").then((res) => {
        if (res.code == 200) {
          this.jdlbList = res.result;
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    init(type, record, taskId, detailId) {
      this.type = type;
      this.disabeld = false;
      this.saveText = "保存";
      this.visible = true;
      //    this.getsexlist();
      this.getsjlist();
      this.getjdlbList();
      //    this.getxwlist();
      if (type == "add") {
        this.form = { content: "" };
        this.form.applyId = record.id;
        //      console.log(record);
        this.title = "添加品牌基地";
      } else if (type == "edit") {
        this.title = "编辑品牌基地";
        this.form = {
          baseName: record.baseName,
          province: record.province,
          baseFoundTime: record.baseFoundTime,
          city: record.city,
          area: record.area,
          baseAddress: record.baseAddress,
          coverImg: record.coverImg,
          content: record.content,
          applyId: record.applyId,
          id: record.id,
          baseType: record.baseType,
        };
        this.$nextTick(() => {
          this.$refs.baseEditor.value = record.content;
        });
      } else if (type === "audit-edit") {
        this.title = "编辑品牌成果";
        this.saveText = "提交";
        this.taskId = taskId;
        this.detailId = detailId;
        this.form = {
          baseName: record.baseName,
          province: record.province,
          baseFoundTime: record.baseFoundTime,
          city: record.city,
          area: record.area,
          baseAddress: record.baseAddress,
          coverImg: record.coverImg,
          content: record.content,
          applyId: record.applyId,
          id: record.id,
          baseType: record.baseType,
        };
        this.$nextTick(() => {
          this.$refs.baseEditor.value = record.content;
        });
      } else {
        this.disabeld = true;
        this.title = "查看品牌基地";
        this.saveText = "关闭";
        this.form = {
          baseName: record.baseName,
          province: record.province,
          baseFoundTime: record.baseFoundTime,
          city: record.city,
          area: record.area,
          baseAddress: record.baseAddress,
          coverImg: record.coverImg,
          content: record.content,
          applyId: record.applyId,
          id: record.id,
          baseType: record.baseType,
        };
        this.$nextTick(() => {
          this.$refs.baseEditor.value = record.content;
        });
      }
      console.log("init, this.form", this.form);
    },
    handleChange(value) {
      console.log(value);
      this.getcjlist(value);
    },
    handleChange1(value) {
      this.getajlist(value);
    },
    beforeUpload(file, fileList) {
      this.handleUpload(file);
      return false;
    },
    sj(url) {
      return baseURL + url;
    },
    handleUpload(file) {
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          console.log("res.message", res.message);
          this.$message.success(`上传成功`);
          this.$refs.coverImg.clearValidate();
          this.form.coverImg = res.message;
          this.$forceUpdate();
          this.loading = false;
        } else {
          this.$message.error("上传失败");
        }
      });
    },
    handleUploadChange({ file, fileList }) {
      console.log("file", file);
      // 更新表单数据 通过验证
      this.form.coverImg = file;
      // 如果需要，可以在这里调用验证方法
      // this.$refs.form.validateField('file');
    },
    getsjlist() {
      getAction("/infrastructure/cnArea/list?parent=0", {}).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.plist = res.result.records;
        }
      });
    },
    getcjlist(id) {
      getAction("/infrastructure/cnArea/list", { parent: id }).then((res) => {
        if (res.code == 200) {
          //              console.log(res);
          this.clist = res.result.records;
        }
      });
    },
    getajlist(id) {
      getAction("/infrastructure/cnArea/list", { parent: id }).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.alist = res.result.records;
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
    submit() {
      if (this.disabeld) {
        this.visible = false;
        return false;
      }
      //  	console.log("11111",this.type);
      if (this.form.coverImg) {
        this.$refs.coverImg.clearValidate();
      }
      console.log("this.form", this.form);
      this.$refs.ruleForm.validate((valid, error) => {
        console.log(valid, error);
        if (valid) {
          const dateObj = new Date(this.form.baseFoundTime);
          const year = dateObj.getFullYear();
          const month = dateObj.getMonth() + 1; // 月份是从 0 开始的，所以要加 1
          const date = dateObj.getDate();
          const formattedDate = `${year}-${month
            .toString()
            .padStart(2, "0")}-${date.toString().padStart(2, "0")}`;
          if (this.type == "add") {
            let params = this.form;
            //          console.log("12345678");
            params.baseFoundTime = formattedDate;
            params.applyType = this.applyType;
            postAction("/lxbase/lxApplyBase/add", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("添加成功");
                this.$emit("addBrand");
              } else {
                this.$message.error(res.message);
              }
            });
          } else if ((this.type = "audit-edit")) {
            let params = {
              taskId: this.taskId,
              afterJson: JSON.stringify({ ...this.form }),
              detailId: this.detailId,
            };
            postAction("/audit/lxAuditTask/reSubmitTask", params).then(
              (res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success(res.message || "添加成功");
                  this.$emit("addBrand");
                } else {
                  this.$message.error(res.message);
                }
              }
            );
          } else {
            let params = this.form;
            params.applyType = this.applyType;
            params.baseFoundTime = formattedDate;
            putAction("/lxbase/lxApplyBase/edit", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("编辑成功");
                this.$emit("addBrand");
              } else {
                this.$message.error(res.message);
                this.visible = false;
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}
.imgs {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
